export default __webpack_public_path__ + "static/cotorrito-734cf47eaea04a07c72ce0b6a2ee7756.png";